import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { renderField, renderTextAreaField } from "../components";
import { validateRequired } from "../validation";

const borderStyle = { border: "1px solid #000", padding: 5, lineHeight: 1.5 };

export const MaritalStatusGroup = props => {
  const options = ["Single", "Married", "Divorced", "Widowed"];
  const optionMap = {
    Single: "未婚",
    Married: "已婚",
    Divorced: " 離婚",
    Widowed: "喪偶",
  };
  return options.map(option => {
    return (
      <div key={option} style={{ textAlign: "center", display: "flex" }}>
        <Field
          name="MaritalStatus"
          type="radio"
          component={renderField}
          value={option}
          validate={validateRequired}
        />
        <div style={{ margin: "4px 10px" }}>
          {option} {optionMap[option]}
        </div>
      </div>
    );
  });
};

const EmployeeEmployer = ({ renderValue, isReadOnly }) => (
  <Fragment>
    <table style={{ borderCollapse: "collapse", width: "100%", tableLayout: "fixed" }}>
      <tbody>
        <tr>
          <td style={borderStyle} colSpan={4}>
            <b>
              To be completed by the Employee and please sign the Declaration overleaf <br />
              由僱員填寫及請簽妥背頁聲明
            </b>
            <br />
            <br />
            (Please print in English 請用英文正楷)
          </td>
          <td
            style={{ ...borderStyle, verticalAlign: "middle", fontSize: "20px" }}
            colSpan={4}
          ></td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={4}>
            <b>Employee Name (Name on HKID Card) 僱員姓名</b>
            <br />
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <table
                style={{
                  width: "80%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  borderCollapse: "collapse",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        height: "20px",
                        ...borderStyle,
                      }}
                      id="LastName"
                    >
                      {renderValue({
                        fieldName: "LastName",
                        fieldFormat: "text",
                      })}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                      id="FirstName"
                    >
                      {renderValue({
                        fieldName: "FirstName",
                        fieldFormat: "text",
                      })}
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      Surname 姓
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      Given Name 名
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td style={borderStyle} colSpan={2}>
            <b>Employer’s Name (Policyholder) 公司名稱</b>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              {renderValue({
                fieldName: "CompanyName",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={borderStyle} colSpan={2}>
            <b>Policy No. 保單編號</b>
            <div style={{ marginTop: 10, marginBottom: 10 }} id="PolicyNumber">
              {renderValue({
                fieldName: "PolicyNumber",
                fieldFormat: "text",
              })}
            </div>
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={2}>
            <div style={{ float: "left", width: "20%" }}>
              <b>Sex</b>
              <br />
              性别
            </div>
            <div style={{ float: "right", width: "80%" }} id="Gender">
              <label style={{ width: "100%" }}>
                <input
                  type="radio"
                  name="Gender"
                  value="Male"
                  disabled
                  checked={renderValue({ fieldName: "Gender", fieldFormat: "text" }) === "Male"}
                />{" "}
                Male 男性
              </label>
              <br />
              <label style={{ width: "100%" }}>
                <input
                  type="radio"
                  name="Gender"
                  value="Female"
                  disabled
                  checked={renderValue({ fieldName: "Gender", fieldFormat: "text" }) === "Female"}
                />{" "}
                Female 女性
              </label>
            </div>
          </td>
          <td style={borderStyle} colSpan={2}>
            <b>HKID Card No. 身份證號碼 </b>
            <div style={{ marginTop: 10, marginBottom: 10 }} id="Identification">
              {renderValue({
                fieldName: "Identification",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={borderStyle} colSpan={2}>
            <b>Affiliated Company Name 附屬公司名稱</b>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              {renderValue({
                fieldName: "AffiliatedCompanyName",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={borderStyle} colSpan={2}>
            <b>Affiliated Code 附屬公司編號</b>
            <div style={{ marginTop: 10, marginBottom: 10 }} id="AffiliatedCompanyCode">
            </div>
          </td>
        </tr>
        <tr>
          <td style={{ ...borderStyle, textAlign: "center" }} colSpan={2}>
            <b>Date of Birth 出生日期</b>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "90%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  ...borderStyle,
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                      id="BirthDateYear"
                    >
                      {renderValue({
                        fieldName: "BirthDate",
                        fieldFormat: "date",
                        dateFormat: "YYYY",
                      })}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                      id="BirthDateMonth"
                    >
                      {renderValue({
                        fieldName: "BirthDate",
                        fieldFormat: "date",
                        dateFormat: "MM",
                      })}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                      id="BirthDateDay"
                    >
                      {renderValue({
                        fieldName: "BirthDate",
                        fieldFormat: "date",
                        dateFormat: "DD",
                      })}
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      Y 年
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      M 月
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      D 日
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td style={{ ...borderStyle, textAlign: "center" }} colSpan={2}>
            <b>Employment Date 受僱日期 </b>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "90%",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                      id="JoinDateYear"
                    >
                      {renderValue({
                        fieldName: "JoinDate",
                        fieldFormat: "date",
                        dateFormat: "YYYY",
                      })}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                      id="JoinDateMonth"
                    >
                      {renderValue({
                        fieldName: "JoinDate",
                        fieldFormat: "date",
                        dateFormat: "MM",
                      })}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                      id="JoinDateDay"
                    >
                      {renderValue({
                        fieldName: "JoinDate",
                        fieldFormat: "date",
                        dateFormat: "DD",
                      })}
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      Y 年
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      M 月
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        ...borderStyle,
                      }}
                    >
                      D 日
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td style={borderStyle} colSpan={2}>
            <b>Staff No. (If any) 僱員編號(如適用)</b>
            <div style={{ marginTop: 10, marginBottom: 10 }} id="StaffNo">
              {renderValue({
                fieldName: "StaffNo",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={borderStyle} colSpan={2}>
            <b>Department Code (If any)</b>
            <br />
            部門編號(如適用)
            <div style={{ marginTop: 10, marginBottom: 10 }} id="DepartmentCode">
              <Field
                id="DepartmentCode"
                name="DepartmentCode"
                type="text"
                component={renderField}
                style={{ width: "100%" }}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={2} rowSpan={2}>
            <b>Marital Status 婚姻狀況</b>
            <div style={{ paddingTop: "10px " }}>
              <MaritalStatusGroup />
            </div>
          </td>
          <td style={{ ...borderStyle, height: "25px" }} colSpan={2}>
            <table style={{ width: "80%", marginBottom: 10 }}>
              <tr>
                <td></td>
                <td style={{ textAlign: "center" }}>
                  <b>Monthly Salary 月薪 </b>
                </td>
              </tr>
              <tr>
                <td>
                  <br />
                  HK$
                </td>
                <td style={{ textAlign: "center" }}>
                  <br />
                  {renderValue({
                    fieldName: "Salary",
                    fieldFormat: "text",
                  })}
                </td>
              </tr>
            </table>
          </td>
          <td style={borderStyle} colSpan={4} rowSpan={2}>
            <div style={{ float: "left" }}>
              <b>Remarks 附註 </b>
              <div style={{ marginTop: 10, marginBottom: 10 }} id="Remarks">
                {isReadOnly ? (
                  renderValue({
                    fieldName: "Remarks",
                    fieldFormat: "text",
                  })
                ) : (
                  <Field
                    id="Remarks"
                    name="Remarks"
                    rows="6"
                    cols="50"
                    component={renderTextAreaField}
                    style={{ width: "100%" }}
                  />
                )}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={2}>
            <b>Position 職位</b>
            <div style={{ marginTop: 10, marginBottom: 10 }} id="JobTitle">
              <Field
                id="JobTitle"
                name="JobTitle"
                type="text"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%" }}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={4}>
            <b>Employee Bank A/C No. 僱員銀行戶口號碼</b>
            <table style={{ width: "100%" }}>
              <tr>
                <td style={{ width: "15%" }}>
                  Bank Code: <br />
                  銀行編號
                </td>
                <td style={{ width: "30%" }}>
                  <Field
                    id="BankCode"
                    name="BankCode"
                    type="text"
                    component={renderField}
                    style={{ width: "100%" }}
                  />
                </td>
                <td style={{ width: "10%" }}></td>
                <td style={{ width: "15%" }}>
                  Bank Name: <br />
                  銀行名稱
                </td>
                <td style={{ width: "30%" }}>
                  <Field
                    id="BankName"
                    name="BankName"
                    type="text"
                    component={renderField}
                    style={{ width: "100%" }}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={5}>
                  <br />
                </td>
              </tr>
              <tr>
                <td>
                  Branch Code: <br />
                  分行編號
                </td>
                <td>
                  <Field
                    id="BranchCode"
                    name="BranchCode"
                    type="text"
                    component={renderField}
                    style={{ width: "100%" }}
                  />
                </td>
                <td></td>
                <td>
                  Branch Name: <br />
                  分行名稱
                </td>
                <td>
                  <Field
                    id="BranchName"
                    name="BranchName"
                    type="text"
                    component={renderField}
                    style={{ width: "100%" }}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={5}>
                  <br />
                </td>
              </tr>
              <tr>
                <td>
                  Account No: <br />
                  戶口號碼
                </td>
                <td>
                  <Field
                    id="BankAccount"
                    name="BankAccount"
                    type="text"
                    component={renderField}
                    style={{ width: "100%" }}
                  />
                </td>
              </tr>
            </table>
          </td>
          <td style={borderStyle} colSpan={4} rowSpan={5}>
            <table style={{ borderCollapse: "collapse", width: "100%", tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <td style={{ ...borderStyle, borderRight: "none" }}>
                    {renderValue({
                      fieldName: "AuthorisedSignatureName",
                      fieldFormat: "text",
                    })}
                  </td>
                  <td style={{ width: "5%" }}></td>
                  <td style={{ ...borderStyle, borderLeft: "none" }}>
                    {renderValue({
                      fieldName: "CompletedOn",
                      fieldFormat: "date",
                      dateFormat: "YYYY-MM-DD",
                    })}
                  </td>
                </tr>
                <tr>
                  <td style={{ ...borderStyle, borderRight: "none" }}>
                    {" "}
                    Authorised Signature with Company Chop
                    <br />
                    公司簽署及蓋章{" "}
                  </td>
                  <td style={{ width: "5%" }}></td>
                  <td style={{ ...borderStyle, borderLeft: "none" }}>
                    Date <br />
                    日期{" "}
                  </td>
                </tr>
                <tr>
                  <td style={{ ...borderStyle, textAlign: "center" }} colSpan={3}>
                    <b>AXA CR use only 安盛金融專用 </b>
                  </td>
                </tr>
                <tr>
                  <td style={{ ...borderStyle, textAlign: "center" }} colSpan={3}>
                    <b>I</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ ...borderStyle, textAlign: "center" }} colSpan={3}>
                    <b>C</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={4}>
            <b>Email Address 電郵地址 </b>
            <div style={{ marginTop: 10, marginBottom: 10 }} id="Email">
              <Field
                id="Email"
                name="Email"
                type="text"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%" }}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={4}>
            <b>Do you have other disability income insurance? NO/YES, please give details. </b>
            <br />
            閣下是否持有其他傷殘保險? 否 / 是 , 請詳述
            <Field
              id="OtherDisabilityInsuranceQuestion"
              name="OtherDisabilityInsuranceQuestion"
              type="text"
              component={renderField}
              validate={validateRequired}
              style={{ width: "100%" }}
            />
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={4}>
            <b>Do you engage in any hazardous or organised sport? NO/YES, please give details. </b>
            <br />
            閣下有否參與危險或隊際性運動? 否 / 是 , 請詳述
            <Field
              id="EngageHazardousSportQuestion"
              name="EngageHazardousSportQuestion"
              type="text"
              component={renderField}
              validate={validateRequired}
              style={{ width: "100%" }}
            />
          </td>
        </tr>
        <tr>
          <td style={borderStyle} colSpan={4}>
            <div style={{ marginBottom: "10px" }}>
              <b>Job Duties 工作範圍</b>{" "}
            </div>
            <Field
              id="JobDuty"
              name="JobDuty"
              type="text"
              component={renderField}
              validate={validateRequired}
              style={{ width: "100%" }}
            />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
  </Fragment>
);

EmployeeEmployer.propTypes = {
  renderValue: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
};

export default EmployeeEmployer;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/AXAHD202404/EmployeeEmployer.js